import React, { useRef, useState } from 'react';
import { View, TouchableOpacity, StyleSheet, Text } from 'react-native';
import Dropdown from './Dropdown';
import TagList from './TagList';
import { Icons, PositionModal } from '@hmsexp/component-library';
import { get, noop, set } from 'lodash';
import AddButton from './AddButton';

const MultiSelect = ({
  options,
  mode = 'multi',
  placeholder = 'Select...',
  onSelect,
  selected = [],
  selectLabel = ''
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [path, setPath] = useState([options]);
  const [labelPath, setLabelPath] = useState(['']);
  const [filterFocused, setFilterFocused] = useState(false);
  const testRef = useRef(null);
  const [backText, setBackText] = useState('Back');
  const [dropdownParentPosition, setDropdownParentPostion] = useState(null);
  const isStatic = get(options, 'source', 'static') === 'static';
  const key = get(options, 'key', 'key');
  const currentOptions = path[path.length - 1];
  const styles = createStyles(filterFocused, open);
  const [loading, setLoading] = useState(false);
  const [dynamicOptions, setDynamicOptions] = useState([]);

  const toggleSelect = item => {
    const hasChildren = Array.isArray(item.children) && item.children.length > 0;

    if (hasChildren) {
      setPath([...path, item.children]);
      setLabelPath(prev => [...prev, item.fullLabel]);
      setSearch('');
    } else {
      if (mode === 'single') {
        onSelect([item]);
        setOpen(false);
      } else {
        if (selected.some(s => s.fullValue === item.fullValue)) {
          onSelect(selected.filter(s => s.fullValue !== item.fullValue));
        } else {
          onSelect([...selected, item]);
        }
      }
    }
  };

  const goBack = () => {
    if (path.length > 1) {
      setPath(path.slice(0, -1));
      setLabelPath(prev => prev.slice(0, -1));
      setSearch('');
    }
  };

  const handleDropdownOpen = () => {
    setOpen(true);
    testRef.current.measure((fx, fy, width, height, px, py) => {
      setDropdownParentPostion({ x: px, y: py + 3, w: width, h: height });
    });
  };

  const handleDropdownClose = () => {
    setOpen(false);
    setFilterFocused(false);
  };

  const filteredOptions = currentOptions.filter(opt => opt.fullLabel.toLowerCase().includes(search.toLowerCase()));

  return (
    <View style={styles.container} ref={testRef}>
      <TouchableOpacity
        style={mode === 'single' ? styles.singleSelector : styles.multiSelector}
        onPress={mode === 'single' ? handleDropdownOpen : noop}
        onMouseEnter={() => setFilterFocused(true)}
        onMouseLeave={() => setFilterFocused(false)}
        activeOpacity={0.8}>
        {mode === 'multi' ? (
          <>
            <TagList
              selected={selected}
              onRemove={val => {
                onSelect(selected.filter(s => s.fullValue !== val));
              }}
              mode={mode}
            />
            <AddButton onPress={handleDropdownOpen} label={selectLabel} />
            {/* <TouchableOpacity
              style={[styles.addButton, (filterFocused || open) && styles.addButtonFocused]}
              onMouseEnter={() => setFilterFocused(true)}
              onMouseLeave={() => setFilterFocused(false)}
              onPress={handleDropdownOpen}>
              <Text style={styles.addText}>
                <Icons.AddIcon size='S' />
                {selectLabel}
              </Text>
            </TouchableOpacity> */}
          </>
        ) : (
          <Text style={[styles.singleText, selected.length === 0 && { color: '#999' }]}>
            {selected.length > 0 ? selected[0].fullLabel : placeholder}
          </Text>
        )}
        {mode === 'single' && (
          <Text style={styles.caret}>
            <Icons.ChevronDown />
          </Text>
        )}
      </TouchableOpacity>

      <PositionModal visible={open} outsideClick={handleDropdownClose} parentPositions={dropdownParentPosition}>
        <TouchableOpacity onFocus={() => {}} activeOpacity={1}>
          <Dropdown
            options={filteredOptions}
            selected={selected}
            onSelect={toggleSelect}
            search={search}
            setSearch={setSearch}
            canGoBack={path.length > 1}
            onGoBack={goBack}
            backText={labelPath[labelPath.length - 1] || 'Back'}
          />
        </TouchableOpacity>
      </PositionModal>
    </View>
  );
};

export default MultiSelect;

const createStyles = (focused, dropdownOpen) =>
  StyleSheet.create({
    container: { width: '100%', alignSelf: 'center' },

    /** MULTI SELECT **/
    multiSelector: {
      flexDirection: 'row',
      alignItems: 'center',
      width: 'fit-content',
      flexWrap: 'wrap' // allows children to wrap
      // alignItems: 'flex-start',
      // paddingVertical: 6,
      // paddingHorizontal: 8,
      // backgroundColor: '#fff',
      // minHeight: 48
    },
    addButton: {
      borderRadius: 50,
      borderWidth: 1,
      borderColor: '#ced4da',
      paddingHorizontal: 10,
      paddingVertical: 2
    },
    addButtonFocused: { backgroundColor: '#daefff', borderColor: '#b8dfff' },
    addText: { color: '#2d77d0', fontSize: 12 },

    /** SINGLE SELECT **/
    singleSelector: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderColor: focused || dropdownOpen ? '#2d77d0' : '#9BA1AB',
      borderWidth: dropdownOpen ? 1 : 1,
      borderRadius: 50,
      paddingVertical: 2,
      paddingHorizontal: 16,
      backgroundColor: '#FAFBFC'
    },
    singleText: {
      fontSize: 16,
      color: '#111827'
    },
    caret: {
      fontSize: 18,
      color: '#666',
      transform: dropdownOpen ? [{ rotate: '180deg' }] : []
    }
  });
